<template>
  <div id="registar">
    <vue-headful :title="$store.state.option['registar_title-' + lang]" :lang="lang" />
    <titulo></titulo>

    <div class="container text-jsutify mt-5" v-if="ok" v-html="$store.state.option['registarSuc-' + lang]"></div>
    <div class="container" v-else>
      <div class="card card-register mx-auto mt-5">
        <div class="card-body">
          <form @submit.prevent="submit()">
            <div class="form-group m-0">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input type="text" id="firstName" class="form-control" :placeholder="$store.state.option['driver_Name-' + lang]" required="required" autofocus="autofocus" v-model="form.driver_Name" />
                    <label for="firstName">{{$store.state.option['driver_Name-' + lang]}}*</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input type="date" id="date_of_Birth" class="form-control" :placeholder="$store.state.option['date_of_Birth-' + lang]" required="required" autofocus="autofocus" v-model="form.date_of_Birth" maxlength="10" readonly />
                    <label for="date_of_Birth">{{$store.state.option['date_of_Birth-' + lang]}}*</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" style="margin-top:16px;">
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-label-group">
                    <textarea id="address" v-model="form.address" class="form-control" :placeholder="$store.state.option['address-' + lang] + ($store.state.option.address_register > 0 ? '*' : '')"></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input type="text" id="postal_Code" class="form-control" :placeholder="$store.state.option['postal_Code-' + lang]" required="required" v-model="form.postal_Code" />
                    <label for="postal_Code">{{$store.state.option['postal_Code-' + lang]}}<span v-if="$store.state.option.postal_Code_register > 0">*</span></label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input type="text" id="city" class="form-control" :placeholder="$store.state.option['city-' + lang]" required="required" v-model="form.city" />
                    <label for="city">{{$store.state.option['city-' + lang]}}<span v-if="$store.state.option.city_register > 0">*</span></label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-label-group">
                    <select id="country" class="form-control" required="required" v-model="form.country" style="height:50px;">
                      <option value="" selected hidden>{{$store.state.option['country-' + lang]}}*</option>
                      <option :value="dt.countryID" v-for="(dt,index) in $store.state.paises" :key="index">{{dt.country}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input type="text" id="license_Number" class="form-control" :placeholder="$store.state.option['license_Number-' + lang]" required="required" v-model="form.license_Number" />
                    <label for="license_Number">{{$store.state.option['license_Number-' + lang]}}<span v-if="$store.state.option.license_Number_register > 0">*</span></label>
                  </div>
                </div>
                <div class="col-md-6">
                  <!--<div class="form-label-group">
                    <input type="text" id="license_Country" class="form-control" :placeholder="$store.state.option['license_Country-' + lang]" required="required" v-model="form.license_Country" />
                    <label for="license_Country">{{$store.state.option['license_Country-' + lang]}}</label>
                  </div>-->
                  <div class="form-label-group">
                    <select id="license_Country" class="form-control" required="required" v-model="form.license_Country" style="height:50px;">
                      <option value="" selected hidden>{{$store.state.option['license_Country-' + lang]}}<span v-if="$store.state.option.license_Country_register > 0">*</span></option>
                      <option :value="dt.countryID" v-for="(dt,index) in $store.state.paises" :key="index">{{dt.country}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-label-group">
                    <!--<input type="text" id="document_Type" class="form-control" :placeholder="$store.state.option['document_Type-' + lang]" required="required" v-model="form.document_Type" />-->
                    <select id="document_Type" class="form-control" required="required" v-model="form.document_Type" style="height:50px;">
                      <option value="" selected hidden>{{$store.state.option['document_Type-' + lang]}}<span v-if="$store.state.option.document_Type > 0">*</span></option>
                      <option value="0">{{$store.state.option['document_Type-0-' + lang]}}</option>
                      <option value="1">{{$store.state.option['document_Type-1-' + lang]}}</option>
                      <option value="2">{{$store.state.option['document_Type-2-' + lang]}}</option>
                    </select>
                    <!--<label for="document_Type">{{$store.state.option['document_Type-' + lang]}}</label>-->
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input type="text" id="document_Number" class="form-control" :placeholder="$store.state.option['document_Number-' + lang]" required="required" v-model="form.document_Number" />
                    <label for="document_Number">{{$store.state.option['document_Number-' + lang]}}<span v-if="$store.state.option.document_Number > 0">*</span></label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-label-group">
                    <select id="country" class="form-control" required="required" v-model="form.document_Place" style="height:50px;">
                      <option value="" selected hidden>{{$store.state.option['document_Place-' + lang]}}<span v-if="$store.state.option.document_Place > 0">*</span></option>
                      <option :value="dt.countryID" v-for="(dt,index) in $store.state.paises" :key="index">{{dt.country}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input type="number" id="phone_Number" class="form-control" :placeholder="$store.state.option['phone_Number-' + lang]" required="required" v-model="form.phone_Number" />
                    <label for="phone_Number">{{$store.state.option['phone_Number-' + lang]}}<span v-if="$store.state.option.phone_Number > 0">*</span></label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input type="number" id="mobile_Number" class="form-control" :placeholder="$store.state.option['mobile_Number-' + lang]" required="required" v-model="form.mobile_Number" />
                    <label for="mobile_Number">{{$store.state.option['mobile_Number-' + lang]}}<span v-if="$store.state.option.mobile_Number > 0">*</span></label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="form-label-group">
                <input type="email" id="inputEmail" class="form-control" :placeholder="$store.state.option['email1sf23-' + lang]" required="required" v-model="form.email" />
                <label for="inputEmail">{{$store.state.option['email1sf23-' + lang]}}*</label>
              </div>
            </div>
            <div class="form-group">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input type="password" id="inputPassword" class="form-control" :placeholder="$store.state.option['senha332-' + lang]" required="required" v-model="form.password"/>
                    <label for="inputPassword">{{$store.state.option['senha332-' + lang]}}*</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input type="password" id="confirmPassword" class="form-control" :placeholder="$store.state.option['senha123f-' + lang]" required="required" @keydown.enter.prevent="submit" v-model="form.password1" />
                    <label for="confirmPassword">{{$store.state.option['senha123f-' + lang]}}*</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="email_Notification">{{$store.state.option['conta_pessoal_user-email_Notification-' + lang]}}</label>
              <input style="margin-left:10px;" id="email_Notification" v-model="form.email_Notification" type="checkbox">
            </div>
            <a class="btn btn-primary btn-block btn-lg mao text-uppercase" @click="submit()" href="javascript:void(0)">{{$store.state.option['registarConta-' + lang]}}</a>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import titulo from '@/components/titulo'
import { mapMutations } from 'vuex'
import birthDate from '../mixins/birthDate'

export default {
  components: { titulo },
  mixins: [birthDate],
  data () {
    return {
      ok: 0,
      form: {
        email: '',
        password: '',
        password1: '',
        driver_Name: '',
        country: '',
        license_Number: '',
        license_Place: '',
        document_Place: '',
        document_Type: '',
        document_Number: '',
        mobile_Number: '',
        phone_Number: '',
        postal_Code: '',
        city: '',
        address: '',
        date_of_Birth: '',
        email_Notification: true,
        license_Country: ''
      },
      lang: '',
      formattedBirthDate: ''
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_LOAD',
      'SET_TITULO',
      'SET_SUBTITULO',
      'SET_AVISO'
    ]),
    init () {
      if (this.$store.state.option1 && this.$store.state.paises1) {
        this.lang = this.$store.state.lang
        this.SET_TITULO(this.$store.state.option['registar_title-' + this.lang])
        this.SET_SUBTITULO(this.$store.state.option['registar_subtitle-' + this.lang])
        this.SET_LOAD()
        this.ok = 0
      } else {
        this._.delay(this.init, 100)
      }
    },
    submit () {
      if (!this.form.driver_Name) {
        this.SET_AVISO(this.$store.state.option['erro-driver_Name-' + this.lang])
        return
      }
      this.formattedBirthDate = this.form.date_of_Birth
      // verify which date format is used in vuex:
      if (!this.checkAndTransformBirthDate(this.form.date_of_Birth)) {
        return
      } else {
        this.form.date_of_Birth = this.birthDayFromMixin
      }
      if (this.$store.state.option.address_register > 0) {
        if (!this.form.address) {
          this.SET_AVISO(this.$store.state.option['erro-address_register-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.postal_Code_register > 0) {
        if (!this.form.postal_Code) {
          this.SET_AVISO(this.$store.state.option['erro-postal_Code_register-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.city_register > 0) {
        if (!this.form.city) {
          this.SET_AVISO(this.$store.state.option['erro-city_register-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.license_Number_register > 0) {
        if (!this.form.license_Number) {
          this.SET_AVISO(this.$store.state.option['erro-license_Number_register-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.license_Country_register > 0) {
        if (!this.form.license_Place) {
          this.SET_AVISO(this.$store.state.option['erro-license_Country_register-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.document_type_register > 0) {
        if (!this.form.document_Type) {
          this.SET_AVISO(this.$store.state.option['erro-document_Type-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.document_number_register > 0) {
        if (!this.form.document_Number) {
          this.SET_AVISO(this.$store.state.option['erro-document_Number-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.document_Place_register > 0) {
        if (!this.form.document_Place) {
          this.SET_AVISO(this.$store.state.option['erro-document_Place-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.phone_Number_register > 0) {
        if (!this.form.phone_Number) {
          this.SET_AVISO(this.$store.state.option['erro-phone_Number-' + this.lang])
          return
        }
      }
      if (this.$store.state.option.mobile_Number_register > 0) {
        if (!this.form.mobile_Number) {
          this.SET_AVISO(this.$store.state.option['erro-mobile_Number-' + this.lang])
          return
        }
      }
      if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email))) {
        this.SET_AVISO(this.$store.state.option['erro-email1-' + this.lang])
        return
      }
      if (!this.form.password) {
        this.SET_AVISO(this.$store.state.option['erro-pass1-' + this.lang])
        return
      }
      if (this.form.password !== this.form.password1) {
        this.SET_AVISO(this.$store.state.option['erro-rpass1-' + this.lang])
        return
      }
      this.SET_LOAD(true)
      this.ok = 0
      this.axios.post('/drivers/register', this.form).then((res) => {
        this.ok = 1
        this.SET_LOAD()
      }, (er) => {
        if (er.response.data.error) {
          this.SET_AVISO(er.response.data.error)
          return
        }
        if (er.response.data.errors) {
          for (let a in er.response.data.errors) {
            this.SET_AVISO(er.response.data.errors[a][0])
            break
          }
        }
        // this.SET_AVISO(er.response.data.errors || er.response.data.message)
      })
    }
  }
}
</script>
